import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { List, Dialog, Portal, Button, useTheme } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { FUEL_TYPE_OPTIONS } from '../lib/constants';

interface FuelTypeSelectorProps {
  value: string;
  onChange: (value: string) => void;
  style?: any;
}

const FuelTypeSelector: React.FC<FuelTypeSelectorProps> = ({ value, onChange, style }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [showModal, setShowModal] = useState(false);

  const getFuelTypeLabel = (value: string) => {
    const option = FUEL_TYPE_OPTIONS.find(opt => opt.value === value);
    return option ? option.label : value;
  };

  return (
    <>
      <List.Item
        title={getFuelTypeLabel(value)}
        description={t('vehicle.selectFuelType', 'Select fuel type')}
        onPress={() => setShowModal(true)}
        right={props => <List.Icon {...props} icon="chevron-down" />}
        style={[styles.input, style]}
      />

      <Portal>
        <Dialog visible={showModal} onDismiss={() => setShowModal(false)} style={styles.dialog}>
          <Dialog.Title>{t('vehicle.selectFuelType', 'Select Fuel Type')}</Dialog.Title>
          <Dialog.Content>
            {FUEL_TYPE_OPTIONS.map((option) => (
              <List.Item
                key={option.value}
                title={option.label}
                onPress={() => {
                  onChange(option.value);
                  setShowModal(false);
                }}
                style={styles.option}
              />
            ))}
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => setShowModal(false)}>{t('cancel', 'Cancel')}</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
    </>
  );
};

const styles = StyleSheet.create({
  input: {
    marginBottom: 12,
  },
  dialog: {
    maxWidth: 520,
    width: '90%',
    alignSelf: 'center',
  },
  option: {
    paddingVertical: 8,
  },
});

export default FuelTypeSelector; 